import { AxiosResponse } from 'axios';
import { BASE_URL } from 'src/config/api';
import client from '../client';
import { FaqResponse } from 'src/admin-entity/interface/faq/faq.interface';

export const fetchFaqList = (lsBroadcastId: number): Promise<AxiosResponse<FaqResponse[]>> => {
    return client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/faq`);
};

export const createFaq = (
    lsBroadcastId: number,
    question: string,
    answer: string,
    faqAppUserId: number,
    faqAppUserSendDate: string,
): Promise<AxiosResponse<{ success: boolean }>> => {
    return client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/faq`, {
        question,
        answer,
        faqAppUserId,
        faqAppUserSendDate,
    });
};

export const updateFaq = (
    lsBroadcastId: number,
    faqId: number,
    question: string,
    answer: string,
): Promise<AxiosResponse<FaqResponse>> => {
    return client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/faq/${faqId}`, { question, answer });
};

export const deleteFaq = (lsBroadcastId: number, faqId: number): Promise<AxiosResponse<{ success: boolean }>> => {
    return client.delete(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/faq/${faqId}`);
};
